import { createApp } from 'vue'
import options from './SignUpButton.options'

const el = '.kb-component--sign-up-button'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SignUpButtonDOM) => {
            const eventId = SignUpButtonDOM.dataset.eventId
            const successButtonData = SignUpButtonDOM.dataset.successButtonData
                ? JSON.parse(SignUpButtonDOM.dataset.successButtonData)
                : null

            const template = SignUpButtonDOM.innerHTML
            options.template = template
            const component = createApp(options, {
                eventId,
                successButtonData
            }).use(Store)
            component.mount(SignUpButtonDOM)
        })
    }
}
